import { Component, Input } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

@Component({
  selector: 'app-epson-logo',
  templateUrl: './epson-logo.component.html',
  styleUrls: ['./epson-logo.component.scss'],
})
/**
 * Epson rewards circle logo
 */
export class EpsonLogoComponent {
  @Input() animate = false;
  _animateOnHover = false;
  private _small = false;
  private _v2 = false;

  /**
   * Get image src
   * @return {string}
   */
  getSrc(): string {
    if (this.small) {
      return '/assets/images/epson-rewards-logo-small.png';
    }
    return '/assets/images/epson-rewards-logo.png';
  }

  /**
   * Decides if the img src label is small
   * @return {boolean}
   */
  @Input()
  get small(): boolean {
    return this._small;
  }

  /**
   * Sets this img src as a small by using an html attribute
   * @param {any} value
   */
  set small(value: any) {
    this._small = coerceBooleanProperty(value);
  }

  /**
   * Decides if the component uses v2 styling
   * @return {boolean}
   */
  @Input()
  get v2(): boolean {
    return this._v2;
  }

  /**
   * Sets this component v2 property
   * @param {any} value
   */
  set v2(value: any) {
    this._v2 = coerceBooleanProperty(value);
  }

  /**
   * Decides if should animate when hovered
   * @return {boolean}
   */
  @Input()
  get animateOnHover(): boolean {
    return this._animateOnHover;
  }

  /**
   * Sets this img src as animatable on hover
   * @param {any} value
   */
  set animateOnHover(value: any) {
    this._animateOnHover = coerceBooleanProperty(value);
  }
}
